import Vue from 'vue'
import Router from 'vue-router'
import statusList from '@/components/statusList'
import statusUpdate from '@/components/statusUpdate'
import Login from '@/components/Login'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'statusList',
      component: statusList
    },
    {
      path: '/update/:id',
      name: 'statusUpdate',
      component: statusUpdate
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }

  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js